import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'

const Backyard = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Backyard Design App to Plan Layouts, Create Zones, and Visualize Furniture"
        subtitle={<>Design your backyard virtually with our layout planner. Map yard zones, test furniture, explore landscaping ideas, and build your ideal outdoor living space.</>}
        bg={headerBg}
        meta={{
          title: 'Backyard Design App | Virtual Planner for Backyard Layout & Ideas',
          description: 'Create your dream backyard with our design app. Plan layouts, arrange furniture, explore DIY backyard ideas, and experiment with landscape designs before you commit.'
        }}
        alt="Virtual backyard design app interface showing layout planning and furniture arrangement tools"
      />
      <Join
        title="Join 10+ Million Users Designing Backyards With"
        postfix=""
        description="Create a custom outdoor space that fits your lifestyle using the DecorMatters backyard design app. Whether you're planning a grill station, cozy firepit, or kid-friendly play zone, our app lets you arrange, design, and visualize it all. Upload a photo of your yard or start with a template to test layouts, experiment with landscape designs, and try real products from top outdoor furniture brands — all before spending a dime."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Design Backyard Zones for Relaxing, Dining, and Entertaining</H2>
            </Show>
            <Text>
              Use our DIY backyard layout planner to create functional outdoor zones — from cooking and dining to relaxing and gardening. Plan your furniture arrangement, map out yard layouts, and preview outdoor decor from trusted retailers. Whether
              you're working with a small yard or large backyard, DecorMatters makes it easy to design an outdoor living space that flows naturally and fits your daily life.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Design Backyard Zones for Relaxing, Dining, and Entertaining</H2>
            </Show>
            <Image src={img1} alt="Backyard layout planner app creating separate zones for outdoor cooking, lounging, gardening, and seating" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>A Backyard Design App Featured by Top Home Experts</H2>
            </Show>
            <Text>
              Recommended by House & Garden, Realtor.com, and Architectural Digest, DecorMatters is more than a layout app — it's your personal garden planner, yard visualization tool, and outdoor decor assistant. Upload your own backyard photo,
              explore 3D backyard layouts, and get personalized product suggestions powered by AI. Design with confidence and bring your outdoor vision to life.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>A Backyard Design App Featured by Top Home Experts</H2>
            </Show>
            <Image src={img2} alt="AI-powered backyard design app suggesting outdoor furniture and garden layout ideas on a phone screen" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Premium Backyard Design Tools</H2>
            </Show>
            <Text>
              Upgrade to DecorMatters Premium for exclusive features that make backyard planning even easier. Use augmented reality (AR) to preview furniture in your outdoor space, erase photo backgrounds, and save unlimited design drafts. With
              access to custom templates, curated decor collections, and enhanced design games, you'll have everything you need to plan a polished, personalized backyard.
            </Text>
            <Button onClick={openLogin}>Unlock Premium Tools</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Premium Backyard Design Tools</H2>
            </Show>
            <Image src={img3} alt="Backyard AR design feature previewing patio furniture and landscaping elements in a real outdoor space" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img4} alt="Mobile app showing 3D backyard design preview with firepit, outdoor lighting, and sectional seating" />
            <Content>
              <H2>Download the Best Backyard Design App and Start Creating</H2>
              <Text>
                Ready to transform your yard into a stunning outdoor retreat? Download the DecorMatters backyard design app and explore tools for furniture planning, landscaping layout, and DIY backyard projects. Whether you're starting from scratch
                or refreshing an existing space, our app helps you design smarter and bring your outdoor dreams to life.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Backyard
